module.exports = __webpack_public_path__ + "media/images/front/program_notify-61a20d2cacd588bb724e4c4126ae775d.jpg";